import React, { memo, useContext, useEffect, useState, useMemo, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import { NavLink } from "react-router-dom";
import { GoSignOut } from "react-icons/go";
import EliaButton from "./EliaButton";
import i18n from "../i18n";

const Header = memo(({ sideOpen, setEntrepriseName, toggleRightSidebar }) => {
  const { user, logout, fetchUser } = useContext(AuthContext);
  const { theme, toggleTheme } = useTheme();
  const [currentLanguage, setCurrentLanguage] = useState(() => localStorage.getItem("langue") || "fr");

  useEffect(() => {
    if (!user) {
      fetchUser();
    }
  }, [user, fetchUser]);

  useEffect(() => {
    i18n.changeLanguage(currentLanguage);
  }, [currentLanguage]);

  const handleLanguage = useCallback(() => {
    const newLang = currentLanguage === "fr" ? "en" : "fr";
    i18n.changeLanguage(newLang);
    setCurrentLanguage(newLang);
    localStorage.setItem("langue", newLang);
  }, [currentLanguage]);

  return (
    <header className={`header ${sideOpen ? "header-open" : ""}`}>
      <div className="header-container">
        {user ? (
          <ul className="header-nav">
            {(user?.roles.includes("ROLE_SUPERADMIN") || user?.roles.includes("ROLE_COMMERCIAL")) && (
              <li
                className="header-nav_item header-nav_item_user elia-logo"
                onClick={toggleRightSidebar}
                style={{ cursor: "pointer" }}
              >
                <EliaButton />
              </li>
            )}
            {user && (
              <li className="header-nav_item header-nav_item_user">
                {user.roles.includes("ROLE_SUPERADMIN") ? (
                  <NavLink className="user-icon button-icon" to={"/users"}>
                    {user.firstName}
                  </NavLink>
                ) : !user.roles.includes("ROLE_SSO") && (
                  <NavLink className="button button-icon" to={"/users"}>
                    {user.firstName}
                  </NavLink>
                )}
              </li>
            )}
            <li>
              <button className="button-icon language" onClick={handleLanguage}>
                {currentLanguage === "fr" ?
                  <img className="language-logo" src="../assets/france.png" />
                  :
                  <img className="language-logo" src="../assets/united-kingdom.png" />
                }
                {currentLanguage}
              </button>
            </li>
            <li onClick={toggleTheme} className="header-nav_item">
              <div className="header-nav_item_button">
                <span className={`header-nav_item_button_choices ${theme === 'light' ? 'choices_light' : 'choices_dark'}`}></span>
              </div>
            </li>
            <li className="header-nav_item">
              <button
                className="button button-icon logout"
                aria-label="déconnexion"
                onClick={logout}
              >
                <GoSignOut />
              </button>
            </li>
          </ul>
        ) : (
          <h2>Connectez-vous</h2>
        )}
      </div>
    </header>
  );
});

export default Header;